module.exports = __webpack_public_path__ + "img/shit-hits-fan.4da04139.png";